import React from 'react'

const ButtonSpan = ({ onMouseDown, onMouseUp, ...props }) => {
	const handleMouseDown = event => {
		event.preventDefault()
		onMouseDown && onMouseDown(event)
	}

	const handleMouseUp = event => {
		event.preventDefault()
		onMouseUp && onMouseUp(event)
	}

	return <span {...props} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp} />
}

export default ButtonSpan